/**
 * @generated SignedSource<<6b3c4e8e97c0e7fd60d70ef2576fba60>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AncestryRelationship = "ANCESTOR" | "DESCENDANT" | "DIRECT_REPORT" | "MANAGER" | "OTHER" | "SELF" | "SIBLING";
export type ProfileSettingsQuery$variables = {};
export type ProfileSettingsQuery$data = {
  readonly viewer: {
    readonly account: {
      readonly hrisIntegrated: boolean | null;
      readonly isSingleUserAccount: boolean;
      readonly primaryAdmin: {
        readonly email: string;
        readonly fullName: string;
        readonly id: string;
        readonly image: string;
      } | null;
    };
    readonly activeDelegation: {
      readonly id: string;
    } | null;
    readonly settings: {
      readonly department: string | null;
      readonly fullName: string | null;
      readonly image: string | null;
      readonly manager: string | null;
      readonly managerDisabled: boolean | null;
      readonly organization: string | null;
      readonly theme: string | null;
      readonly timezonePreferences: {
        readonly preferredTimezone: {
          readonly timezone: {
            readonly description: string;
            readonly name: string;
            readonly utcOffset: number;
          };
          readonly userLabel: string;
        };
      };
      readonly title: string | null;
    };
    readonly user: {
      readonly id: string;
      readonly image: string;
      readonly internalAttributes: {
        readonly manager: {
          readonly activeRecurring1on1Event: {
            readonly recurrenceRule: ReadonlyArray<string | null> | null;
            readonly start: string | null;
          } | null;
          readonly email: string;
          readonly firstName: string;
          readonly fullName: string;
          readonly id: string;
          readonly image: string;
          readonly internalAttributes: {
            readonly manager: {
              readonly email: string;
              readonly firstName: string;
              readonly fullName: string;
              readonly id: string;
              readonly image: string;
              readonly isGuest: boolean;
              readonly lastName: string;
              readonly relationshipToViewer: AncestryRelationship | null;
            } | null;
          } | null;
          readonly isGuest: boolean;
          readonly lastName: string;
          readonly relationshipToViewer: AncestryRelationship | null;
        } | null;
      } | null;
      readonly isGuest: boolean;
    };
    readonly " $fragmentSpreads": FragmentRefs<"TimezoneSelector_viewer">;
  };
};
export type ProfileSettingsQuery = {
  response: ProfileSettingsQuery$data;
  variables: ProfileSettingsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "Delegation",
  "kind": "LinkedField",
  "name": "activeDelegation",
  "plural": false,
  "selections": [
    (v0/*: any*/)
  ],
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isGuest",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "start",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "recurrenceRule",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "relationshipToViewer",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "manager",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    (v4/*: any*/),
    (v7/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/),
    (v10/*: any*/)
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSingleUserAccount",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hrisIntegrated",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "primaryAdmin",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    (v4/*: any*/),
    (v9/*: any*/),
    (v2/*: any*/)
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "UserSettings",
  "kind": "LinkedField",
  "name": "settings",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "manager",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "department",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "organization",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "managerDisabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TimezonePreferences",
      "kind": "LinkedField",
      "name": "timezonePreferences",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserTimezone",
          "kind": "LinkedField",
          "name": "preferredTimezone",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TimeZone",
              "kind": "LinkedField",
              "name": "timezone",
              "plural": false,
              "selections": [
                (v15/*: any*/),
                (v16/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "utcOffset",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "userLabel",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "theme",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProfileSettingsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserInternalAttributes",
                "kind": "LinkedField",
                "name": "internalAttributes",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "manager",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/),
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Event",
                        "kind": "LinkedField",
                        "name": "activeRecurring1on1Event",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v2/*: any*/),
                      (v10/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserInternalAttributes",
                        "kind": "LinkedField",
                        "name": "internalAttributes",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/)
            ],
            "storageKey": null
          },
          (v17/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TimezoneSelector_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ProfileSettingsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserInternalAttributes",
                "kind": "LinkedField",
                "name": "internalAttributes",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "manager",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/),
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Event",
                        "kind": "LinkedField",
                        "name": "activeRecurring1on1Event",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v0/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v2/*: any*/),
                      (v10/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserInternalAttributes",
                        "kind": "LinkedField",
                        "name": "internalAttributes",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v0/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v0/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v0/*: any*/)
            ],
            "storageKey": null
          },
          (v17/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TimeZone",
            "kind": "LinkedField",
            "name": "supportedTimezones",
            "plural": true,
            "selections": [
              (v16/*: any*/),
              (v15/*: any*/)
            ],
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "de5cb6c1aa6260ebbd8a19ad4bb47a57",
    "id": null,
    "metadata": {},
    "name": "ProfileSettingsQuery",
    "operationKind": "query",
    "text": "query ProfileSettingsQuery {\n  viewer {\n    activeDelegation {\n      id\n    }\n    user {\n      id\n      image\n      isGuest\n      internalAttributes {\n        manager {\n          id\n          fullName\n          activeRecurring1on1Event {\n            start\n            recurrenceRule\n            id\n          }\n          firstName\n          lastName\n          email\n          image\n          relationshipToViewer\n          isGuest\n          internalAttributes {\n            manager {\n              id\n              fullName\n              firstName\n              lastName\n              email\n              image\n              isGuest\n              relationshipToViewer\n            }\n            id\n          }\n        }\n        id\n      }\n    }\n    account {\n      isSingleUserAccount\n      hrisIntegrated\n      primaryAdmin {\n        id\n        fullName\n        email\n        image\n      }\n      id\n    }\n    settings {\n      fullName\n      image\n      title\n      manager\n      department\n      organization\n      managerDisabled\n      timezonePreferences {\n        preferredTimezone {\n          timezone {\n            name\n            description\n            utcOffset\n          }\n          userLabel\n        }\n      }\n      theme\n    }\n    ...TimezoneSelector_viewer\n    id\n  }\n}\n\nfragment TimezoneSelector_viewer on Viewer {\n  supportedTimezones {\n    description\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "e26c43309f9b19c2da0a5f3e27a732e6";

export default node;
